import Config from "./Config"
import axios from './Axios'

const API = {
    // Dashboard APIs
    dashboardApi: (params) => CallApi(`${Config.baseURL}/leads/summary`, "GET", params),
    fetchDashboardStats: () => CallApi(`${Config.baseURL}/leads/monitoring/stats`, "GET"),

    // Queue Management APIs
    fetchQueuedLeads: (params) => CallApi(`${Config.baseURL}/queues/queued`, "GET", params),
    fetchQueuedLeadById: (leadId) => CallApi(`${Config.baseURL}/queues/queued/${leadId}`, "GET"),
    transferQueuedLead: (leadId, data) => CallApi(`${Config.baseURL}/queues/queued/${leadId}/transfer`, "POST", data),
    bulkTransferQueuedLeads: (data) => CallApi(`${Config.baseURL}/queues/queued/bulk-transfer`, "POST", data),

    //Queue Delete APIs
    removeFromQueue: (leadId) => CallApi(`${Config.baseURL}/queues/queued/${leadId}`, "DELETE"),
    bulkRemoveFromQueue: (data) => CallApi(`${Config.baseURL}/queues/queued/bulk-remove`, "DELETE", data),

    fetchQueuedCounts: () => CallApi(`${Config.baseURL}/queues/queued/counts`, "GET"),
    fetchQueuedStats: (params) => CallApi(`${Config.baseURL}/queues/queued/stats`, "GET", params),
    reassignQueuedLead: (leadId, data) => CallApi(`${Config.baseURL}/queues/queued/${leadId}/reassign`, "POST", data),
    fetchMyQueuedLeads: (params) => CallApi(`${Config.baseURL}/queues/my-queued`, "GET", params),
    exportQueuedLeads: (params) => CallApi(`${Config.baseURL}/queues/queued/export`, "GET", params),
    fetchQueueDashboard: () => CallApi(`${Config.baseURL}/queues/queue-dashboard`, "GET"),

    // System APIs
    fetchSystemHealth: () => CallApi(`${Config.baseURL}/leads/health`, "GET"),
    fetchSystemMetrics: () => CallApi(`${Config.baseURL}/leads/metrics`, "GET"),

    // Auth APIs
    GoogleLogin: (data) => CallApi(`${Config.baseURL}/auth/google-login`, "POST", data),
    LoginUser: (params) => CallApi(`${Config.baseURL}/auth/login`, 'POST', params),
    ForgotPassword: (params) => CallApi(`${Config.baseURL}/auth/forgot-password`, 'POST', params),
    ResetPassword: (params) => CallApi(`${Config.baseURL}/auth/reset-password`, 'POST', params),
    ChangePassword: (params) => CallApi(`${Config.baseURL}/auth/change-password`, 'POST', params),

    // User Management
    userGetAll: () => CallApi(`${Config.baseURL}/auth/allUser`, 'GET'),
    getServiceAgents: () => CallApi(`${Config.baseURL}/auth/service-agents`, 'GET'),
    UserPagination: (params) => CallApi(`${Config.baseURL}/auth/Pagination`, 'GET', params),
    registeruser: (params) => CallApi(`${Config.baseURL}/auth/register`, 'POST', params),
    GetUserById: (id) => CallApi(`${Config.baseURL}/auth/userById/${id}`, 'GET'),
    getCurrentUser: () => CallApi(`${Config.baseURL}/auth/currentagent`, 'GET'),
    // Marketing Leads page (MARKETING role, read-only)
    getMarketingLeads: (params) => CallApi(`${Config.baseURL}/marketing-leads`, 'GET', params),
    getMarketingLeadDomains: () => CallApi(`${Config.baseURL}/marketing-leads/domains`, 'GET'),
    // Account Sessions page (admin only)
    getSessions: (params) => CallApi(`${Config.baseURL}/auth/sessions`, 'GET', params),
    // Ends this login's session. Token passed in because logout clears localStorage right after.
    logoutSession: (token, endReason = 'logout') =>
        CallApi(`${Config.baseURL}/auth/logout`, 'POST', { endReason }, { Authorization: `Bearer ${token}` }),
    UpdateUser: (id, data) => CallApi(`${Config.baseURL}/auth/updateUser/${id}`, 'PATCH', data),
    // Super admin on/off for an ADMIN user. Backend allows only admin@premiumusedautoparts.com.
    setSuperAdmin: (id, isSuperAdmin) => CallApi(`${Config.baseURL}/auth/super-admin/${id}`, 'PATCH', { isSuperAdmin }),
    ToggleStatus: (id, isActive) => CallApi(`${Config.baseURL}/auth/status/${id}`, 'PUT', { isActive }),
    updateIsActive: (_id, isActive) => CallApi(`${Config.baseURL}/auth/deactivate/${_id}`, "PUT", { isActive }),

    // User Deletion/Restore
    DeleteUserSoft: (ids) => CallApi(`${Config.baseURL}/auth/soft`, 'DELETE', { ids }),
    GetDeletedData: (params) => CallApi(`${Config.baseURL}/auth/deleteList`, 'GET', params),
    HardDeleteRecord: (ids) => CallApi(`${Config.baseURL}/auth/hard`, 'DELETE', { ids }),
    RestoreRecord: (_id) => CallApi(`${Config.baseURL}/auth/restore/${_id}`, 'PUT'),

    // Domain Mapping (DomainGroup)
    getDomainGroups: (params) => CallApi(`${Config.baseURL}/domain-groups`, 'GET', params),
    createDomainGroup: (data) => CallApi(`${Config.baseURL}/domain-groups`, 'POST', data),
    updateDomainGroup: (id, data) => CallApi(`${Config.baseURL}/domain-groups/${id}`, 'PATCH', data),
    deleteDomainGroup: (id) => CallApi(`${Config.baseURL}/domain-groups/${id}`, 'DELETE'),
    setDomainGroupMembership: (groupId, userId, enabled) =>
        CallApi(`${Config.baseURL}/domain-groups/${groupId}/members/${userId}`, 'PATCH', { enabled }),

    // Lead Management
    SubmitLead: (params) => CallApi(`${Config.baseURL}/leads/submit-inbound-lead`, 'POST', params),
    GetLeadById: (id) => CallApi(`${Config.baseURL}/leads/leadById/${id}`, 'GET'),
    UpdateLead: (id, data) => CallApi(`${Config.baseURL}/leads/updateLead/${id}`, 'PATCH', data),

    // Yard Reassignment History — "History Notes" CRUD
    addYardReassignmentNote: (leadId, historyId, text) =>
        CallApi(`${Config.baseURL}/leads/${leadId}/yard-reassignment-history/${historyId}/notes`, 'POST', { text }),
    updateYardReassignmentNote: (leadId, historyId, noteId, text) =>
        CallApi(`${Config.baseURL}/leads/${leadId}/yard-reassignment-history/${historyId}/notes/${noteId}`, 'PATCH', { text }),
    deleteYardReassignmentNote: (leadId, historyId, noteId) =>
        CallApi(`${Config.baseURL}/leads/${leadId}/yard-reassignment-history/${historyId}/notes/${noteId}`, 'DELETE'),
    transferLead: (leadId, data) => CallApi(`${Config.baseURL}/leads/${leadId}/transfer`, "POST", data),
    UpdateZohoStatus: (leadId, status) => CallApi(`${Config.baseURL}/leads/lead/${leadId}/zoho-status`, 'PUT', { status }),
    getReviewLeads: (params) => CallApi(`${Config.baseURL}/review-leads`, 'GET', params),
    getReviewLeadById: (id) => CallApi(`${Config.baseURL}/review-leads/${id}`, 'GET'),
    recoverReviewLead: (id, data) => CallApi(`${Config.baseURL}/review-leads/${id}/recover`, 'POST', data),
    deleteReviewLead: (id) => CallApi(`${Config.baseURL}/review-leads/${id}`, 'DELETE'),
    bulkDeleteReviewLeads: (ids) => CallApi(`${Config.baseURL}/review-leads/bulk-delete`, 'POST', { ids }),

    // Lead Pagination & Search
    leadPagination: (params) => CallApi(`${Config.baseURL}/leads/Pagination`, 'GET', params),
    leadSearch: (params) => CallApi(`${Config.baseURL}/leads/Search`, 'GET', params),
    leadAgentPagination: (params) => {
        const queryString = new URLSearchParams(params).toString();
        return CallApi(`${Config.baseURL}/leads/Pagination/agent?${queryString}`, 'GET');
    },

  leadGetAll: ({
    agentId,
    status,
     dateField,
    source,
    page,
    limit,
    sortBy,
    order,
    startDate,
    endDate,
    search,
    searchSource,
    searchFields,
    view,
    advancePaymentFrom,
    advancePaymentTo,
    type,
    isFollowUpPage,
    agentMode,
    tierType,
    tierLane,
    zohoDocAllow,    
    payementAllow,   
    leadStatus ,
         invoiceStatus,      
                    purchaseOrderStatus,
                    stageHistoryStage,     
            stageHistoryDate ,  
            stageHistoryEndDate,     
        zohoStatus,
        shipmentDeliveryStatus,
        trackingComplete,
        orderProcessComplete,
        relocate,
        yardRefundReceived,
        customerRefundStatus,
        phoneNumberFormat,
        timezoneDecision,
        fields,
        excludeCanceledOrders
}, { signal } = {}) => {
    let url = `${Config.baseURL}/leads/allleads?`;

    const params = {
        agentId, 
        status, 
        source, 
            dateField,
        page, 
        limit, 
        sortBy, 
        order,
        startDate, 
        endDate, 
        search, 
        // Sent only by My Leads, with a search.
        searchSource,
        // Sent with a search by pages that have the "Search in" dropdown.
        searchFields,
        // view: sent by every lead list page (LeadController LEAD_VIEW_FIELDS).
        // advancePaymentFrom / advancePaymentTo: sent only by Advance Payment (ms).
        view,
        advancePaymentFrom,
        advancePaymentTo,
        type, 
        isFollowUpPage, 
        agentMode, 
        tierType,
        tierLane,
        zohoDocAllow, 
        payementAllow,
        leadStatus,
           invoiceStatus,      
                    purchaseOrderStatus,
                    stageHistoryStage,     
            stageHistoryDate ,
            stageHistoryEndDate,       
        zohoStatus,
        relocate,
        shipmentDeliveryStatus,
        trackingComplete,
        customerRefundStatus,
        yardRefundReceived,
        phoneNumberFormat,
        timezoneDecision,
        // Comma-separated field list. Omitted by every caller but the Dispute
        // page's lead dropdown; omitting it returns the full document as before.
        fields,
        // Sent only by Order Process: leave out orders the customer canceled.
        excludeCanceledOrders,
        orderProcessComplete: typeof orderProcessComplete === 'object'
            ? JSON.stringify(orderProcessComplete)
            : orderProcessComplete
    };

    // Better check: only add if value exists and is not empty string
    Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
            url += `${key}=${encodeURIComponent(params[key])}&`;
        }
    });

    url = url.endsWith("&") ? url.slice(0, -1) : url;
    return CallApi(url, "GET", {}, {}, { signal });
},

    // Lead Deletion/Restore
    DeleteLeadSoft: (ids) => CallApi(`${Config.baseURL}/leads/soft`, 'DELETE', { ids }),
    GetDeletedLead: (params) => CallApi(`${Config.baseURL}/leads/deleteList`, 'GET', params),
    HardDeleteLead: (ids) => CallApi(`${Config.baseURL}/leads/hard`, 'DELETE', { ids }),
    RestoreLead: (_id) => CallApi(`${Config.baseURL}/leads/restore/${_id}`, 'PUT'),

    // Follow-Ups
    GetMyFollowUps: ({
        id,
        leadStage,
        leadType,
        page,
        limit,
        sortBy,
        sortOrder,
        search,
        startDate,
        endDate
    }) => {
        let url = `${Config.baseURL}/leads/follow-ups?userId=${id}&leadStage=${leadStage}`;

        if (leadType) url += `&leadType=${leadType}`;
        if (page) url += `&page=${page}`;
        if (limit) url += `&limit=${limit}`;
        if (sortBy) url += `&sortBy=${sortBy}`;
        if (sortOrder) url += `&sortOrder=${sortOrder}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        if (startDate) url += `&startDate=${startDate}`;
        if (endDate) url += `&endDate=${endDate}`;

        console.log(url, ' MY Follow Ups URL');
        return CallApi(url, 'GET');
    },

    // Customer Management
    GetAllCustomer: ({
        page,
        limit,
        sortBy,
        order,
        startDate,
        endDate,
        search
    }) => {
        let url = `${Config.baseURL}/customer/all?`;

        if (page) url += `page=${page}&`;
        if (limit) url += `limit=${limit}&`;
        if (sortBy) url += `sortBy=${sortBy}&`;
        if (order) url += `order=${order}&`;
        if (startDate) url += `startDate=${startDate}&`;
        if (endDate) url += `endDate=${endDate}&`;
        if (search) url += `search=${search}&`;

        url = url.endsWith("&") ? url.slice(0, -1) : url;
        return CallApi(url, "GET");
    },

    DeleteCustomer: (ids) => CallApi(`${Config.baseURL}/customer/dlt`, 'DELETE', { ids }),
    CheckCustomerByPhone: (phone) => CallApi(`${Config.baseURL}/customer/checkByPhone/${phone}`, 'GET'),
    GetCustomerDetails: (customerId) => CallApi(`${Config.baseURL}/customer/details/${customerId}`, 'GET'),

    // Yard Management
    createYard: (params) => CallApi(`${Config.baseURL}/yard-details/new-yard`, 'POST', params),
    getYardWithoutPagnation: () => CallApi(`${Config.baseURL}/yard-details/yards`, 'GET'),

    yardGetAll: ({
        page,
        limit,
        sortBy,
        order,
        search,
    }) => {
        let url = `${Config.baseURL}/yard-details/all-yards?`;

        if (page) url += `page=${page}&`;
        if (limit) url += `limit=${limit}&`;
        if (sortBy) url += `sortBy=${sortBy}&`;
        if (order) url += `order=${order}&`;
        if (search) url += `search=${search}&`;

        url = url.endsWith("&") ? url.slice(0, -1) : url;
        return CallApi(url, "GET");
    },

    GetYardById: (id) => CallApi(`${Config.baseURL}/yard-details/yard/${id}`, 'GET'),
    UpdateYard: (id, data) => CallApi(`${Config.baseURL}/yard-details/update-yard/${id}`, 'PATCH', data),

    // Yard Deletion/Restore
    SoftDeleteYard: (ids) => CallApi(`${Config.baseURL}/yard-details/soft`, 'DELETE', { ids }),
    GetDeletedYard: (params) => CallApi(`${Config.baseURL}/yard-details/deleteList`, 'GET', params),
    HardDeleteYard: (ids) => CallApi(`${Config.baseURL}/yard-details/hard`, 'DELETE', { ids }),
    RestoreYard: (_id) => CallApi(`${Config.baseURL}/yard-details/restore/${_id}`, 'PUT'),

    // Gmail APIs
    FetchEmails: (params) => CallApi(`${Config.baseURL}/api/emails`, "GET", params),
    SendEmail: (data) => CallApi(`${Config.baseURL}/api/emails/send-email`, "POST", data),
    SetupGmailWatch: (data) => CallApi(`${Config.baseURL}/api/setup-gmail-watch`, "POST", data),
    HandleEmailNotification: (data) => CallApi(`${Config.baseURL}/api/handle-email-notification`, "POST", data),

    // RingCentral
    MakeCall: (params) => CallApi(`${Config.baseURL}/ringcentral/make-call`, 'POST', params),

    // Zoho Sign
    SendZohoSign: async (payload) => CallApi('/api/zoho/send', 'POST', payload),
    GetZohoDocumentStatus: async (requestId) => CallApi(`/api/zoho/document-status/${requestId}`, 'GET'),

    // Issue Management
    getAllIssues: (params) => {
        let url = `${Config.baseURL}/api/issues?`;
        Object.keys(params || {}).forEach((key) => {
            if (params[key] !== undefined && params[key] !== null) {
                url += `${key}=${params[key]}&`;
            }
        });
        url = url.endsWith("&") ? url.slice(0, -1) : url;
        return CallApi(url, "GET");
    },

    getIssueById: (id) => CallApi(`${Config.baseURL}/api/issues/${id}`, "GET"),

    // One field's change log — field is issue_created_date | yard_comments |
    // customer_comments | status
    getIssueFieldHistory: (id, field) => CallApi(`${Config.baseURL}/api/issues/${id}/field-history/${field}`, "GET"),
    createIssue: (data) => CallApi(`${Config.baseURL}/api/issues`, "POST", data),
    updateIssue: (id, data) => CallApi(`${Config.baseURL}/api/issues/${id}`, "PUT", data),
    softDeleteIssue: (id) => CallApi(`${Config.baseURL}/api/issues/soft/${id}`, "DELETE"),
    restoreIssue: (id) => CallApi(`${Config.baseURL}/api/issues/restore/${id}`, "PUT"),
    hardDeleteIssue: (id) => CallApi(`${Config.baseURL}/api/issues/hard/${id}`, "DELETE"),

    getAllDeletedIssues: (params) => {
        let url = `${Config.baseURL}/api/issues/deleted/all?`;
        Object.keys(params || {}).forEach((key) => {
            if (params[key] !== undefined && params[key] !== null) {
                url += `${key}=${params[key]}&`;
            }
        });
        url = url.endsWith("&") ? url.slice(0, -1) : url;
        return CallApi(url, "GET");
    },

    // RR Visualization APIs

    // ==================== RR VISUALIZATION APIs ====================

    // GET the live rings, one per domain group, so the dashboard never has to
    // keep its own list of lanes in step by hand
    fetchRRRings: (params) => CallApi(`${Config.baseURL}/rr-visualization/rings`, 'GET', params),

    // GET all live inbound RR ring states
    fetchRRCursors: (params) => CallApi(`${Config.baseURL}/rr-visualization/rr-cursors`, 'GET', params),

    // GET detailed history for a specific live ring
    fetchRRHistory: (ringId, params) => CallApi(`${Config.baseURL}/rr-visualization/rr-history/${ringId}`, 'GET', params),

    // GET agent churn analysis
    fetchAgentChurn: (params) => CallApi(`${Config.baseURL}/rr-visualization/agent-churn`, 'GET', params),

    // GET simulation of next assignments for a live ring
    simulateNextAssignment: (ringId, params) => CallApi(`${Config.baseURL}/rr-visualization/simulate-next/${ringId}`, 'GET', params),

    // GET performance metrics
    fetchRRPerformance: (params) => CallApi(`${Config.baseURL}/rr-visualization/performance`, 'GET', params),

    // GET timeline data for cursor progression on a live ring
    fetchCursorTimeline: (ringId, params) => CallApi(`${Config.baseURL}/rr-visualization/timeline/${ringId}`, 'GET', params),

    // GET fairness metrics
    fetchFairnessMetrics: (params) => CallApi(`${Config.baseURL}/rr-visualization/fairness`, 'GET', params),

    // POST reset cursor for a specific live ring
    resetRRCursor: (ringId, data) => CallApi(`${Config.baseURL}/rr-visualization/reset-cursor/${ringId}`, 'POST', data),

    // GET dashboard summary
    fetchRRDashboard: (params) => CallApi(`${Config.baseURL}/rr-visualization/dashboard`, 'GET', params),

    // GET active agents by tier
    fetchActiveAgentsByTier: (tier, params) => CallApi(`${Config.baseURL}/rr-visualization/active-agents/${tier}`, 'GET', params),

    // GET paginated assignments
    rrAssignmentPagination: (params) => CallApi(`${Config.baseURL}/rr-visualization/assignments/pagination`, 'GET', params),

    // GET export RR data (JSON or CSV)
    exportRRData: (params) => CallApi(`${Config.baseURL}/rr-visualization/export`, 'GET', params),

    // GET RR alerts
    fetchRRAlerts: (params) => CallApi(`${Config.baseURL}/rr-visualization/alerts`, 'GET', params),

    // GET heatmap data
    fetchRRHeatmap: (params) => CallApi(`${Config.baseURL}/rr-visualization/heatmap`, 'GET', params),

    // GET agent sequence for a specific live ring
    fetchAgentSequence: (ringId, params) => CallApi(`${Config.baseURL}/rr-visualization/sequence/${ringId}`, 'GET', params),

    // GET compatibility check - Verifies system is using atomic counter RR
    checkCompatibility: (params) => CallApi(`${Config.baseURL}/rr-visualization/compatibility-check`, 'GET', params),

    // GET debug cursor - Detailed diagnostic for a specific live ring
    debugCursor: (ringId, params) => CallApi(`${Config.baseURL}/rr-visualization/debug-cursor/${ringId}`, 'GET', params),


    // Helper function for multiple simulations
    simulateMultipleSteps: async (ringId, steps = 5) => {
        const simulations = [];
        for (let i = 0; i < steps; i++) {
            const response = await API.simulateNextAssignment(ringId);
            simulations.push(response);
            if (i < steps - 1) {
                await new Promise(resolve => setTimeout(resolve, 100));
            }
        }
        return simulations;
    },

    // In your API.js file - add this with your other API methods

    // GET user status history with filters
    getUserStatusHistory: (userId, params) => CallApi(`${Config.baseURL}/api/status-history/user/${userId}`, 'GET', params),

    // GET all agents status history with filters
    getAllAgentsStatusHistory: (params) => CallApi(`${Config.baseURL}/api/status-history/all`, 'GET', params),

    // GET status report for analytics
    getAgentsStatusReport: (params) => CallApi(`${Config.baseURL}/api/status-history/report`, 'GET', params),

    // GET status statistics for a user
    getUserStatusStats: (userId) => CallApi(`${Config.baseURL}/api/status-history/user/${userId}/stats`, 'GET'),

    // Export status history to CSV/Excel
    exportStatusHistory: (params) => CallApi(`${Config.baseURL}/api/status-history/export`, 'GET', params, { responseType: 'blob' }),

// invoice
// In your API.js file
sendInvoiceEmail: async (emailData) => {
    try {
        const response = await fetch(`${Config.baseURL}/api/send-invoice-email`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${Storage.get("token")}`
            },
            body: JSON.stringify(emailData)
        });
        return await response.json();
    } catch (error) {
        console.error('Error sending email:', error);
        return { success: false, message: 'Network error' };
    }
},
 // ========== DISPUTE APIs ==========
    
    // Create new dispute
    createDispute: (data) => CallApi(`${Config.baseURL}/api/disputes/new-dispute`, 'POST', data),

    // Get all active disputes with pagination, sort, search
    // NOTE: CallApi's 3rd arg (`data`) becomes the axios `params` (query string) for GET
    // requests — it does NOT go in the 4th arg (`headers`). Passing params as the 4th
    // arg silently sent them as HTTP headers instead, so no query string ever reached
    // the server and the backend always fell back to its page=1&limit=10 default.
    getActiveDisputes: (params) => CallApi(`${Config.baseURL}/api/disputes/active-disputes`, 'GET', params),

    // Pre-flight check: does an active dispute already exist for this lead?
    checkDuplicateDispute: (leadId) => CallApi(`${Config.baseURL}/api/disputes/check-duplicate/${leadId}`, 'GET'),

    // Get all disputes without pagination (for dropdowns/exports)
    getAllDisputesList: (params) => CallApi(`${Config.baseURL}/api/disputes/all-disputes-list`, 'GET', params),

    // Get single dispute by ID
    getDisputeById: (id) => CallApi(`${Config.baseURL}/api/disputes/dispute/${id}`, 'GET'),

    // Get a dispute's full status timeline (creation + every status change)
    getDisputeStatusHistory: (id) => CallApi(`${Config.baseURL}/api/disputes/${id}/status-history`, 'GET'),

    // One field's change log — field is dispute_date | dispute_reason | description
    getDisputeFieldHistory: (id, field) => CallApi(`${Config.baseURL}/api/disputes/${id}/field-history/${field}`, 'GET'),

    // Get all deleted disputes with pagination, sort, search
    getDeletedDisputes: (params) => CallApi(`${Config.baseURL}/api/disputes/deleted-disputes`, 'GET', params),

    // Update dispute
updateDispute: (id, data) => CallApi(`${Config.baseURL}/api/disputes/update-dispute/${id}`, 'PATCH', data),
    // Soft delete disputes (single or multiple)
    softDeleteDisputes: (ids) => CallApi(`${Config.baseURL}/api/disputes/soft-delete`, 'DELETE', { ids }),

    // Restore soft-deleted disputes
    restoreDisputes: (ids) => CallApi(`${Config.baseURL}/api/disputes/restore-dispute`, 'PUT', { ids }),

    // Hard delete disputes (permanent)
    hardDeleteDisputes: (ids) => CallApi(`${Config.baseURL}/api/disputes/hard-delete`, 'DELETE', { ids })

}

async function CallApi(url, method = 'GET', data = {}, headers = {}, { signal } = {}) {
    try {
        const response = await axios({
            method,
            url,
            data,
            params: method === 'GET' ? data : {},
            headers,
            // Only a caller that can cancel its request passes a signal.
            ...(signal ? { signal } : {})
        });

        return response.data;
    } catch (err) {
        // The caller cancelled this request itself (a newer one replaced it),
        // so there is nothing to report.
        if (err?.code === 'ERR_CANCELED') {
            return undefined;
        }

        console.log('API ERROR', err);

        if (err?.response?.status === 401 || err?.response?.status === 403) {
            try {
                localStorage.removeItem('token');
                localStorage.removeItem('userData');
                localStorage.removeItem('sidebarFrom');

                window.location='/'
            } catch (e) {
                console.log(e);
            }
        }

        return err?.response?.data;
    }
}

export default API;
